<template>
  <div style="margin-bottom: .6rem;">
  <!-- <div style="position: fixed; top: 0; left: 0; background-color: #ffffff; color: #000000; z-index: 100; width: 100vw; height: 2rem;">
    {{alertText}}
  </div> -->
    <div id="loading-container">
      <div v-if="isLoading">
        <img class="notdata-img" src="../../assets/img/loading-2.gif" alt="loading"/>
        <span class="notdata">加载中</span>
      </div>
      <div v-else class="notdata" id="loading-text" >{{loadText}}</div>
    </div>
    <div v-if="isNoMoreData" class="notdata" >暂时没有更多啦!</div>
  </div>
</template>

<script>
  import scrollService from "../../services/scrollService";

  export default {
    name: "loading",
    props: {
      scrollDiv: String,
      isLoading: Boolean,
      isNoMoreData: Boolean
    },
    data() {
      return {
        touchStartY: 0,
        dy: 0,
        loadText: '继续上拉加载更多',
        alertText: ''
      }
    },
    methods: {
      scrollFunction() {
        if (scrollService.isNearBottom(this.scrollDiv)) {
          if (!this.isNoMoreData && !this.isLoading) {
            this.$emit('get-books');
          }
        }
      }
    },
    mounted() {
      scrollService.addScrollListener(this.scrollDiv, this.scrollFunction);
    },
    beforeDestroy() {
      scrollService.removeScrollListener(this.scrollDiv, this.scrollFunction);
    },
    watch: {
      isLoading(data) {
        if (!data) {
          let container = document.getElementById('loading-container');
          container.style.height = '0';
        }
      }
    }
  }
</script>

<style scoped>
  #loading-container {
    height: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  #loading-container #loading-text {
    transform: scale(0);
  }
</style>



// WEBPACK FOOTER //
// src/components/share/loading.vue